<template>
  <div id="Serwisowy" class="container-fluid">
    <!-- <PanelLog/> -->
    <div style="float: right;height: 40px;position: absolute;z-index: 2;right: 60px;">
      <button
        class="btn btn-outline-secondary"
        style="float: right;margin-right: 5px;"
        v-if="userLog"
        @click="logout"
      >{{ $t("message.logout") }}</button>
    </div>
    <div id='error'>
      <div id="info">
          <span>{{ $t("message.uups") }}</span><br>
          <span>{{ $t("message.dosnt_work_sorry") }}</span><br>
          <span style="font-size:15px">{{ $t("message.finished_service") }} {{ver.serwis_stop}}.</span><br><br>
          <div class="button" style="width: max-content;">
            <button class="btn btn-primary btn-block" style="font-size: 0.7em;" @click="downloadIt">
            <i class="fa fa-file-pdf"></i>&nbsp;&nbsp; {{ $t("message.download_full_pdf") }}</button>
          </div>
      </div>
    </div>
  </div>
</template>
<script>

// import PanelLog from "./PanelLog";

export default {
  name:"Serwisowy",
  data(){
    return{
      link: (this.$i18n.locale == 'pl')?"https://app.pulsar.pl/pulsar-files/cennik_pulsar.pdf":"https://app.pulsar.pl/pulsar-files/pulsar_pricelist.pdf",
      userLog: false,
      ver:[],
    }
  },
  component:{
    // PanelLog
  },
  methods: {
    logout() {
      sessionStorage.clear();
      this.userLog = false;
      this.$router.push({ name: "LoginPage" });
    },
    getVersion(){
      this.$http.get('pricelist-version')
        .then((res) => {
          this.ver = res.data[0];
          this.changeCB = this.ver.serwis;
        })
    },
    downloadIt(){

      let userSession = sessionStorage.getItem("userLog");
      let obj = JSON.parse((userSession));

      let file_name = (this.$i18n.locale == 'pl') ?
        "Pulsar_Cennik_Detal_"+this.$store.state.version.version.pulsarNumer+".pdf" :
        "Pulsar_Pricelist_"+this.$store.state.version.version.pulsarNumer+".pdf";

      this.$http.get('https://app.pulsar.pl/api/pobierz', {responseType: 'blob', params:{
        email: (obj.email) ? obj.email : null, //"grzegorzj@pulsar.pl",//
        file: file_name,
        lang: this.$i18n.locale
      }})
        .then((response) => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file_name); //or any other extension
            document.body.appendChild(link);
            link.click();

        });
    },
  },
  created() {
    // let userSession = sessionStorage.getItem("userLog");

    // if (userSession == null && process.env.VUE_APP_Log_In == true) {
    //   this.$router.push({ name: "LoginPage" });
    //   this.userLog = false;
    // } else {
    //   this.userLog = true;
    // }

    // this.getVersion();
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Roboto");

body {
  background: #f8f8f8;
  width: 100vw;
}
html {
  overflow-y: scroll;
}
#error{
background:url("../assets/error404.jpg");
background-color: #ECECEF;
background-position-x: 0%;
background-position-y: 0%;
background-repeat: repeat;
background-size: auto;
background-size: contain;
background-repeat: no-repeat;
height: 600px;
background-position: top;
}

#info{
  width: 100%;
text-align: center;
bottom: 40px;
position: absolute;
font-size: 25px;
}
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 100px;
  background-color: #f8f8f8;
  font-size: 20px;
}
#app .logo {
  width: 320px;
  padding: 15px 0;
}
.container-fluid {
  max-width: 1520px;
  padding: 40px;
  background: #fff;
  position: relative;
}
.versionOuter {
  position: relative;
}
.overlay {
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 999;
}
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: #ddd;
  color: #2c3e50;
  border-radius: 7.5px;
  padding: 10px 15px 15px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #ddd;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

.btn-primary,
.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  background: #23497f;
  color: #fff;
  border-color: #23497f;
}

.btn-default,
.btn-default:not(:disabled):not(.disabled).active,
.btn-default:not(:disabled):not(.disabled):active,
.show > .btn-default.dropdown-toggle {
  background: #fff;
  color: #23497f;
  border-color: #fff;
  border: 1px solid #23497f;
  border-left: 1px solid #23497f;
  border-right: 1px solid #23497f;
  border: 0;
}
.btn-link,
.btn-link:not(:disabled):not(.disabled).active,
.btn-link:not(:disabled):not(.disabled):active,
.show > .btn-link.dropdown-toggle {
  color: #23497f;
}
h2 {
  position: relative;
}
a[disabled="disabled"] {
  pointer-events: none;
}

.form-check-label {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.btnRight {
  font-size: 14px;
  padding: 8px;
}

</style>




// WEBPACK FOOTER //
// src/components/Serwisowy.vue